import { render, staticRenderFns } from "./CandidateLayout.vue?vue&type=template&id=31e71494"
import script from "./CandidateLayout.vue?vue&type=script&lang=js"
export * from "./CandidateLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31e71494')) {
      api.createRecord('31e71494', component.options)
    } else {
      api.reload('31e71494', component.options)
    }
    module.hot.accept("./CandidateLayout.vue?vue&type=template&id=31e71494", function () {
      api.rerender('31e71494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/front/Candidate/Layout/CandidateLayout.vue"
export default component.exports